import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-navy-900/80 backdrop-blur-md border-b border-navy-700" data-id="element-231">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-232">
        <div className="flex items-center gap-2" data-id="element-233">
          <div className="w-3 h-3 bg-accent-teal rounded-sm shadow-[0_0_10px_rgba(0,212,170,0.5)]" data-id="element-234"></div>
          <span className="font-mono font-bold text-xl text-white tracking-wider" data-id="element-235">
            ROGUEHAVEN
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-400" data-id="element-236">
          <a href="#platform" className="hover:text-white transition-colors" data-id="element-237">
            Platform
          </a>
          <a href="#insights" className="hover:text-white transition-colors" data-id="element-238">
            Insights
          </a>
          <a href="#pricing" className="hover:text-white transition-colors" data-id="element-239">
            Pricing
          </a>
          <a href="#about" className="hover:text-white transition-colors" data-id="element-240">
            About
          </a>
        </div>

        <div className="flex items-center gap-4" data-id="element-241">
          <button className="hidden md:block text-sm font-medium text-white hover:text-accent-teal transition-colors" data-id="element-242">
            Log In
          </button>
          <button className="bg-accent-teal/10 text-accent-teal border border-accent-teal/20 hover:bg-accent-teal hover:text-navy-900 transition-all px-5 py-2.5 rounded-md text-sm font-semibold" data-id="element-243">
            Start Free Audit
          </button>
        </div>
      </div>
    </nav>;
}